import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'messages', sv, true, true)
i18n.addResourceBundle('en', 'messages', en, true, true)

export function buildMessagesRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/messages',
      component: lazyRouteComponent(
        () => import('./MessagesPage'),
        'MessagesPage',
      ),
    }),
    // Most-specific paths first so /newMessage isn't shadowed by /$messageId.
    createRoute({
      getParentRoute: () => parent,
      path: '/newMessage',
      component: lazyRouteComponent(
        () => import('./ComposeMessagePage'),
        'ComposeMessagePage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/messages/$messageId',
      component: lazyRouteComponent(
        () => import('./MessageDetailPage'),
        'MessageDetailPage',
      ),
    }),
  ]
}
